(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.DSDOriginalsInlineView) root.DSDOriginalsInlineView = api.create(root);
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  var CSS = ['dsd-originals-library-lib001.css', 'dsd-originals-polish-libp01.css'];
  var JS = ['dsd-originals-core-lib001.js', 'dsd-originals-routes-libp01.js', 'dsd-originals-integration-r9.js', 'dsd-originals-playback-observer-libp01.js', 'dsd-originals-page-views-r1122.js', 'dsd-originals-public-counts-r1149.js', 'dsd-originals-library-lib001.js', 'dsd-originals-polish-core-libp01.js', 'dsd-originals-polish-libp01.js', 'dsd-originals-reading-place-libp01.js', 'dsd-originals-engagement-libp01.js'];
  function asset(value, name, origin) {
    try {
      var url = new URL(value, origin);
      var local = url.protocol === 'http:' && ['127.0.0.1', 'localhost', '[::1]'].includes(url.hostname) && url.origin === origin;
      return (url.protocol === 'https:' || local) && (url.origin === origin || url.hostname === 'cdn.shopify.com') &&
        url.pathname.endsWith('/assets/' + name) && !url.username && !url.password && !url.hash ? url.href : null;
    } catch (_error) { return null; }
  }
  function matchingConfig(config, expected) {
    return Boolean(config && expected && config.signedIn === expected.signedIn &&
      (config.signedIn ? /^[a-f0-9]{64}$/.test(config.requestScope || '') && config.requestScope === expected.readerScope : expected.readerScope === 'guest-page-v1') &&
      Array.isArray(config.chapters) && config.chapters.some(function (chapter) { return chapter.id === expected.chapterId && chapter.audioRevision === expected.audioRevision; }));
  }
  function create(win) {
    var doc = win.document, host = null, mountedRoot = null, pending = null, openedPath = '', returnUrl = '', returnScroll = 0, originalChildren = [], sourceConfig = null, sourceDocument = null, ready = false;
    var resources = Object.create(null), returnButton = null, priorFocus = null;
    function visible() { return Boolean(host && !host.hidden); }
    function show(on) {
      if (!host) return;
      host.hidden = !on;
      if (mountedRoot) mountedRoot.dispatchEvent(new win.CustomEvent('dsd:originals:reader-visibility', { detail: { visible: on } }));
      originalChildren.forEach(function (item) { if (item.node.isConnected) item.node.hidden = on ? true : item.hidden; });
      if (on) win.dispatchEvent(new win.Event('resize'));
    }
    function routeIsReader() {
      var url = new URL(win.location.href);
      var routes = win.DSDOriginalsRoutes;
      if (routes && routes.publicPath(url.pathname, routes.read(doc.querySelector('[data-originals-public-routes]')))) return true;
      return url.pathname === openedPath && ['chapter', 'series', 'library', 'home'].includes(url.searchParams.get('view'));
    }
    function syncRoute() {
      if (!host) return;
      var on = routeIsReader();
      show(on);
      if (!on) {
        if (priorFocus && priorFocus.isConnected && typeof priorFocus.focus === 'function') priorFocus.focus({ preventScroll: true });
        win.scrollTo({ top: returnScroll, behavior: 'instant' });
      }
    }
    function close() {
      if (!visible()) return;
      if (win.history.state && win.history.state.dsdOriginalsInlineReader === true) win.history.back();
      else {
        win.history.pushState({}, '', returnUrl);
        win.dispatchEvent(new win.PopStateEvent('popstate'));
      }
    }
    function findResource(parsed, name) {
      var nodes = parsed.querySelectorAll('script[src],link[rel="stylesheet"][href]');
      for (var i = 0; i < nodes.length; i++) {
        var valid = asset(nodes[i].getAttribute('src') || nodes[i].getAttribute('href'), name, win.location.origin);
        if (valid) return valid;
      }
      throw new Error('reader_resource_unavailable');
    }
    function load(parsed, name, css) {
      if (resources[name]) return resources[name];
      var existing = Array.prototype.some.call(doc.querySelectorAll(css ? 'link[rel="stylesheet"][href]' : 'script[src]'), function (node) {
        return Boolean(asset(node.getAttribute(css ? 'href' : 'src'), name, win.location.origin));
      });
      if (existing) return Promise.resolve();
      var url = findResource(parsed, name);
      resources[name] = new Promise(function (resolve, reject) {
        var node = doc.createElement(css ? 'link' : 'script');
        var timer = win.setTimeout(function () { node.remove(); delete resources[name]; reject(new Error('reader_resource_timeout')); }, 15000);
        node.onload = function () { win.clearTimeout(timer); resolve(); };
        node.onerror = function () { win.clearTimeout(timer); node.remove(); delete resources[name]; reject(new Error('reader_resource_failed')); };
        if (css) { node.rel = 'stylesheet'; node.href = url; } else { node.src = url; node.async = false; }
        doc.head.appendChild(node);
      });
      return resources[name];
    }
    function finish(options) {
      var chain = Promise.resolve();
      CSS.forEach(function (name) { chain = chain.then(function () { return load(sourceDocument, name, true); }); });
      JS.forEach(function (name) { chain = chain.then(function () { if (!options.current()) throw new Error('reader_account_changed'); return load(sourceDocument, name, false); }); });
      return chain.then(function () {
        if (!options.current()) throw new Error('reader_account_changed');
        ready = true; show(true);
        host.dispatchEvent(new win.CustomEvent('shopify:section:load', { bubbles: true }));
        if (returnButton) returnButton.focus({ preventScroll: true });
        win.scrollTo({ top: 0, behavior: 'instant' });
        return mountedRoot;
      });
    }
    function open(options) {
      if (pending) return pending;
      var target = new URL(options.url, win.location.origin);
      var routes = win.DSDOriginalsRoutes;
      var registry = routes && routes.read(doc.querySelector('[data-originals-public-routes]'));
      var nativeRoute = routes && routes.publicPath(target.pathname, registry) && !target.searchParams.has('view');
      var route = nativeRoute ? routes.parse(target.search, target.pathname, registry) : {
        view: target.searchParams.get('view'), seriesId: target.searchParams.get('series'), chapterId: target.searchParams.get('chapter')
      };
      if (target.origin !== win.location.origin || (!nativeRoute && target.pathname !== '/') || !['chapter','series'].includes(route.view) ||
          route.seriesId !== 'just-the-homie' || route.view === 'chapter' && route.chapterId !== options.chapterId) return Promise.reject(new Error('reader_route_invalid'));
      if (host && !matchingConfig(sourceConfig, options)) return Promise.reject(new Error('reader_account_changed'));
      if (host) {
        if (!options.current()) return Promise.reject(new Error('reader_account_changed'));
        win.history.pushState({ dsdOriginalsInlineReader: true }, '', target.href);
        if (!ready) return finish(options);
        show(true);
        win.dispatchEvent(new win.PopStateEvent('popstate'));
        win.scrollTo({ top: 0, behavior: 'instant' });
        return Promise.resolve(mountedRoot);
      }
      var controller = new AbortController(), timeout = win.setTimeout(function () { controller.abort(); }, 15000);
      pending = win.fetch(target.href, { credentials: 'same-origin', cache: 'no-store', redirect: 'error', headers: { Accept: 'text/html' }, signal: controller.signal }).then(function (response) {
        if (!response.ok || !/text\/html/i.test(response.headers.get('content-type') || '')) throw new Error('reader_page_unavailable');
        return response.text();
      }).then(function (html) {
        if (html.length > 2000000 || !options.current()) throw new Error('reader_page_changed');
        var parsed = new win.DOMParser().parseFromString(html, 'text/html');
        sourceDocument = parsed;
        var section = parsed.querySelector('[data-dsd-originals-library]');
        var config = section && section.querySelector('[data-originals-config]');
        if (!section || !config || !matchingConfig(JSON.parse(config.textContent), options)) throw new Error('reader_account_changed');
        var main = doc.querySelector('#MainContent');
        if (!main) throw new Error('reader_host_unavailable');
        section.querySelectorAll('script:not([type="application/json"]),iframe,object,embed').forEach(function (node) { node.remove(); });
        section.querySelectorAll('*').forEach(function (node) { Array.prototype.slice.call(node.attributes).forEach(function (attr) { if (/^on/i.test(attr.name)) node.removeAttribute(attr.name); }); });
        originalChildren = Array.prototype.map.call(main.children, function (node) { return { node: node, hidden: node.hidden }; });
        returnUrl = win.location.href; returnScroll = win.scrollY; openedPath = target.pathname; priorFocus = doc.activeElement;
        sourceConfig = JSON.parse(config.textContent);
        host = doc.createElement('div'); host.dataset.originalsInlineReaderHost = 'true'; host.hidden = true;
        mountedRoot = doc.importNode(section, true);
        var nav = doc.createElement('nav'), button = doc.createElement('button');
        nav.className = 'dsd-originals__nav'; button.type = 'button'; returnButton = button;
        var context = doc.querySelector('[data-originals-account-context]');
        var labels = context ? JSON.parse(context.textContent) : {};
        button.textContent = labels.closeLabel || 'Close'; button.addEventListener('click', close); nav.appendChild(button);
        (mountedRoot.querySelector('.dsd-originals__shell') || mountedRoot).prepend(nav);
        host.appendChild(mountedRoot); main.appendChild(host);
        win.history.pushState({ dsdOriginalsInlineReader: true }, '', target.href);
        return finish(options);
      }).catch(function (error) {
        if (host) { show(false); win.history.replaceState({}, '', returnUrl); }
        throw error;
      }).finally(function () { win.clearTimeout(timeout); pending = null; });
      return pending;
    }
    win.addEventListener('popstate', syncRoute);
    return { open: open, visible: visible, isRoot: function (root) { return root === mountedRoot; }, close: close };
  }
  return { create: create, asset: asset, matchingConfig: matchingConfig };
});
